import { Infer, array, enums, is, object, optional, string, validate } from 'superstruct';

import { useFeatureServices } from './use-feature-services';

const VehicleData = optional(
  array(
    object({
      carlineId: string(),
      description: string(),
      backgroundImage: string(),
      jellyBeanImageFrontView: optional(string()),
      jellyBeanImageSideView: optional(string()),
      showIIHSLogo: optional(enums(["true", "false"])),
      IIHSImagePath: optional(string()),
      showConsumerReportsLogo: optional(enums(["true", "false"])),
      consumerReportsImagePath: optional(string())
    }),
  ),
);

const Content = object({
  suvs: VehicleData,
  sedans: VehicleData,
  compacts: VehicleData,
  electric_vehicles: VehicleData,
  categoryOrder: array(string())
});

export type FeatureAppContent = Infer<typeof Content>;

export function useFeatureAppContent(): FeatureAppContent {
  const { 'fa-content-service': contentService } = useFeatureServices();
  const content = contentService?.content;

  const [error] = validate(content, Content);

  if (error) console.error(error);

  return is(content, Content)
    ? content
    : {
      sedans: [],
      suvs: [],
      compacts: [],
      electric_vehicles: [],
      categoryOrder: []
    };
}
